// extracted by mini-css-extract-plugin
module.exports = {"grid":"ArtistIndexPosters-grid-3IW9C"};